import { Alert } from 'react-bootstrap';

import { PushIssue, pushIssueLabel } from '../utils';

type Props = {
  issues: ReadonlyArray<PushIssue>;
  title?: string;
  variant?: 'danger' | 'warning' | 'info';
  className?: string;
};

/** Every issue the server reported, all at once: never only the first. */
export function PushIssueList({ issues, title, variant = 'danger', className = 'mb-2' }: Props): JSX.Element | null {
  if (issues.length === 0) {
    return null;
  }
  return (
    <Alert variant={variant} className={className}>
      {title ? (
        <div className="font-weight-bold mb-1">
          {title} ({issues.length})
        </div>
      ) : null}
      <ul className="mb-0 pl-3">
        {issues.map((issue, index) => (
          <li key={index}>{pushIssueLabel(issue)}</li>
        ))}
      </ul>
    </Alert>
  );
}
